import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import axios from '../../../_services/api/axios';
import withErrorHandler from '../../../_hoc/withErrorHandler';
import * as actionCreators from '../../../_store/actions/index';
import { getTranslate } from 'react-localize-redux';
import {toastr} from 'react-redux-toastr'
import ReactTooltip from 'react-tooltip'

import { PageTemplate, Header, PageTitle, GreyBox, Flex, Machine, Confirm } from 'components'
import EditMachineModal from './EditMachineModal';

class MachinesPage extends Component {
	state = {
		machineDetails: false,
		machineToDelete: false,
	}
	componentDidMount() {
		this.props.onFetchMachines();
		/*if(this.props.match.params.id) {
			this.props.onFetchMachine(this.props.match.params.id);
		}*/
	}
	componentDidUpdate() {
		if(!this.state.machineDetails && this.props.match.params.id) {
			this.setState({
				machineDetails: this.props.match.params.id
			},() => {
				this.props.onFetchMachine(this.props.match.params.id);
			});
		}
		else if(this.state.machineDetails && !this.props.match.params.id) {
			this.setState({
				machineDetails: false
			},() => 
				this.props.onResetMachine()
			);
		}
		if(this.props.machine.deleted) {
            toastr.success(this.props.translate('machinespage.success.deleted.title'), this.props.translate('machinespage.success.deleted.text')); 
    		this.props.onCalculatorMachineReset();
			this.props.onFetchMachines();
		}
		if(this.props.machine.fetched) {
			ReactTooltip.rebuild();
		}
	}
    componentWillUnmount = () => {
    	this.props.onResetMachine();
    	this.props.onCalculatorMachineReset();
    }

   	onDeleteCancelHandler = ( event ) => {
   		event.preventDefault();
   		this.setState({machineToDelete : false})
   	}
   	onDeleteConfirmHandler = ( id, event ) => {
   		event.preventDefault();
   		this.setState({machineToDelete : id})
   	}
   	onDeleteHandler = ( event ) => {
   		event.preventDefault();
   		this.props.onCalculatorMachineDelete(this.state.machineToDelete);
   		this.setState({machineToDelete : false})
   	}

	render() {
		var machineModal = "";
		if(this.props.machine.fetched) {
			machineModal = (<EditMachineModal machine={this.props.machine.machine} onUpdated={this.props.onFetchMachines}/>);
		}
		let confirm = "";
		if(this.state.machineToDelete) {
			confirm = (
				  <Confirm onCancel={this.onDeleteCancelHandler} onConfirm={this.onDeleteHandler} title={this.props.translate('machinespage.delete.label')} text={this.props.translate('machinespage.delete.text')}/>
			)
		}
	  	return (
		    <PageTemplate header={<Header />} appendComponent={confirm ? confirm : machineModal}>
		      <PageTitle>{this.props.translate('machinespage.title')}</PageTitle>
		      <Flex gutter="15" move="true">
			    {this.props.state.machines.map((machine, index) =>
			    	<Machine key={index} machine={machine} onDeleteHandler={this.onDeleteConfirmHandler.bind(this, machine.id)}/>
		    	)}
			    <Machine type="addnew" theme="light" />
			  </Flex>
		    </PageTemplate>
	  	)
	}
}

const mapStateToProps = state => {
    return {
        defaults: state.defaults,
        state: state.calculatorMachines,
        machine: state.calculatorMachine,
        translate: getTranslate(state.locale)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onFetchMachines: () => dispatch(actionCreators.calculatorMachinesFetch()),
        onFetchMachine: (id) => dispatch(actionCreators.calculatorMachineFetch(id)),
        onResetMachine: () => dispatch(actionCreators.calculatorMachineFetchReset()),
        onCalculatorMachineDelete: (id) => dispatch(actionCreators.calculatorMachineDelete(id)),
        onCalculatorMachineReset: () => dispatch(actionCreators.calculatorMachineDeleteReset()),
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(withErrorHandler(MachinesPage, axios));


// WEBPACK FOOTER //
// ./src/components/pages/MachinesPage/index.js